import type * as React from 'react';

function SvgAccount(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg fill="none" height="1em" viewBox="0 0 16 16" width="1em" {...props}>
      <circle cx="8" cy="4.5" fill="currentColor" r="3.5" />
      <path
        d="M14.5 14.5C14.5 15 11.5899 15 8 15C4.41015 15 1.5 15 1.5 14.5C1.5 10.9101 4.41015 8.5 8 8.5C11.5899 8.5 14.5 10.9101 14.5 14.5Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default SvgAccount;
